import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Docs from "./pages/Docs";
import Widgets from "./pages/Widgets";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import MachineDetail from "./pages/MachineDetail";
import SessionView from "./pages/SessionView";
import TeamSettings from "./pages/TeamSettings";
import EnrollDesktop from "./pages/EnrollDesktop";
import { Privacy, Terms } from "./pages/Legal";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/docs" element={<Docs />} />
        {/* Widget gallery (docs/widget-gallery-page.md): the eight MCP
            widgets rendered live against demo fixtures. */}
        <Route path="/widgets" element={<Widgets />} />
        {/* Phase 10 Track C: the tiers from docs/archive/pricing-strategy.md. */}
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/dashboard" element={<Dashboard />} />
        {/* Phase 7 Track A: deep-linkable destinations of the four-tab IA
            (tonight is the bare /dashboard; swarm/schedules/activity routes). */}
        <Route path="/dashboard/:tab" element={<Dashboard />} />
        <Route path="/machines/:id" element={<MachineDetail />} />
        <Route path="/sessions/:id" element={<SessionView />} />
        <Route path="/teams/:id" element={<TeamSettings />} />
        {/* Desktop one-click enrollment (docs/tauri-desktop.md "One-click
            enrollment via localhost callback"): the tray opens this with
            ?port=&state=; consent mints a single-use enroll token and
            hands it to the 127.0.0.1 listener. */}
        <Route path="/enroll/desktop" element={<EnrollDesktop />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
